import { produce } from 'immer';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseEntity, ID } from '../models';
import { map } from 'rxjs/operators';
import { filterNil } from './rxjs.helpers';

export abstract class EntityStateService<T extends BaseEntity> {
  private _selected$ = new BehaviorSubject<T>(null);

  readonly selected$: Observable<T>;
  readonly selectedId$: Observable<ID>;
  readonly isSaved$: Observable<boolean>;

  get selected(): T {
    return this._selected$.getValue();
  }

  get selectedId(): ID {
    return this.selected ? this.selected.id : null;
  }

  get isSaved(): boolean {
    const selected = this.selected;
    return !!(selected && selected.id);
  }

  constructor() {
    this.selected$ = this._selected$.asObservable();
    this.selectedId$ = this._selected$.asObservable().pipe(
      filterNil,
      map(selected => selected.id)
    );
    this.isSaved$ = this._selected$.asObservable().pipe(map(selected => !!(selected && selected.id)));
  }

  select(entity: T): void {
    this._selected$.next(produce<T>(entity, draft => draft));
  }

  deselect(): void {
    this._selected$.next(null);
  }
}
